import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter101 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        1. 二項分布の式
        </Header>

        　二項分布は成功確率<InlineMath>{`\\displaystyle p `}</InlineMath>の試行を <InlineMath>{`\\displaystyle N `}</InlineMath>回行い、その成功回数<InlineMath>{`\\displaystyle r `}</InlineMath>を確率変数とする確率分布の事です。一般的には以下の様な確率質量関数として定義されています。正規分布などの説明に用いられる確率密度関数ではなく、確率質量関数となっているのは<InlineMath>{`\\displaystyle r `}</InlineMath>が正の整数しか取らない離散値だからです。

        <BlockMath>{`
          \\frac{N!}{r! \(N-r\)!} \\times p^r \\times \\left(1-p\\right)^{N-r} \\,\\,\\,\\, \\cdot \\cdot \\cdot \\cdot \\,\\,\\,\\, \\left(1\\right) 
        `}</BlockMath>

          　本章では、二項分布をくじ引きを例に説明しています。くじが全部で<InlineMath>{`\\displaystyle n `}</InlineMath>個あり、その中の<InlineMath>{`\\displaystyle \\theta `}</InlineMath>個が当たりとします。そうすると、一回目のくじ引きであたりのくじを引く確率は<InlineMath>{` \\displaystyle \\frac{\\theta}{n} `}</InlineMath>となります。はずれのくじを引く確率は<InlineMath>{` \\displaystyle 1-\\frac{\\theta}{n} `}</InlineMath>となります。あたりのくじを引く回数が<InlineMath>{`\\displaystyle r `}</InlineMath>回、はずれのくじを引く回数は<InlineMath>{` \\displaystyle N-r`}</InlineMath>回なので、例えば、最初の<InlineMath>{`\\displaystyle r `}</InlineMath>回連続であたりのくじを引き、その後、<InlineMath>{`\\displaystyle 1-r `}</InlineMath>回連続ではずれのくじを引く確率は、

           <BlockMath>{`
               
              \\left(\\frac{\\theta}{n}\\right)^r \\times \\left(\\frac{n-\\theta}{n}\\right)^{N-r} \\,\\,\\,\\, \\cdot \\cdot \\cdot \\cdot \\,\\,\\,\\, \\left(2\\right) 

          `}</BlockMath>

となります。後は、その組み合わせを考える必要があります。その組み合わせは高校数学で習ったとおり、<InlineMath>{`\\displaystyle N `}</InlineMath>中、 <InlineMath>{`\\displaystyle r `}</InlineMath>回のあたりを引く確率なので、 <InlineMath>{`\\displaystyle {}_n \\mathrm{C}_r =  \\frac{N!}{r! \\left(N-r\\right)!} `}</InlineMath>となり、

          <BlockMath>{`
           \\frac{N!}{r! \(N-r\)!} \\times \\left(\\frac{\\theta}{n}\\right)^r \\times \\left(\\frac{n-\\theta}{n}\\right)^{N-r} \\,\\,\\,\\, \\cdot \\cdot \\cdot \\cdot \\,\\,\\,\\, \\left(3\\right) 
          `}</BlockMath>

となります。

        <Header as='h1'>2. pythonによる計算例</Header>

        <SyntaxHighlighter language="python" style={darcula}>

{`import numpy as np import scipy
import scipy
from scipy.stats import binom
import matplotlib.pyplot as plt


def plot_binomial():

  x = np.arange(100)

  n = 100
  p = 0.3
  mean, var, skew, kurt = binom.stats(n, p, moments='mvsk')
  print(mean)
  print(var)
  print(skew)
  print(kurt)

  plt.xlabel('$r$')
  plt.ylabel('$B(n,p)$')
  plt.title('binomial distribution n={}, p={}'.format(n,p))
  plt.grid(True)
  y = binom.pmf(x,n,p)

  plt.plot(x,y)
  plt.savefig('binomial.png') 
  
if __name__ == "__main__":
  plot_binomial()`}

        </SyntaxHighlighter>

        <Header as='h1'>3. グラフ</Header>

        <img style={{"width":"100%", "margin":"0 auto"}} src={`${process.env.PUBLIC_URL}/images/binomial.png`} alt="binomial" />

      </div>
    )   
  }
}

export default Chapter101;
